export var ReservationListMedicalFoodPreferenceType;
(function (ReservationListMedicalFoodPreferenceType) {
    ReservationListMedicalFoodPreferenceType["CRQLAR_MEDICAL"] = "CRQLAR_MEDICAL";
    ReservationListMedicalFoodPreferenceType["CRQLAR_FOOD_ALLERGY"] = "CRQLAR_FOOD_ALLERGY";
    ReservationListMedicalFoodPreferenceType["CRQLAR_FOOD_TYPE"] = "CRQLAR_FOOD_TYPE";
})(ReservationListMedicalFoodPreferenceType || (ReservationListMedicalFoodPreferenceType = {}));
export var ArrivalsStayPeriod;
(function (ArrivalsStayPeriod) {
    ArrivalsStayPeriod["CHECKING_IN"] = "CHECKING_IN";
    ArrivalsStayPeriod["CHECKING_OUT"] = "CHECKING_OUT";
    ArrivalsStayPeriod["STAYING"] = "STAYING";
})(ArrivalsStayPeriod || (ArrivalsStayPeriod = {}));
